<template>
    <div>
        <div
            v-for="page in pages"
            :key="'page' + page.id"
            :class="{
                'mt-2': page.page != '1'
            }"
        >
            <Page
                :publication_id="publication_id"
                :publication="publication"
                :unit_group="unit_group"
                :unit="unit"
                :page="page"
                :disabled="disabled"
                :available_standards="available_standards"
                :state_grade="state_grade"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import unit_layout from '@/common/unit_layout'

import Page from '@/components/unit/layout/Page'

export default {
    data: () => ({
        unit_layout: unit_layout,
        pages: []
    }),
    props: [
        'publication_id',
        'publication',
        'unit_group',
        'unit',
        'disabled',
        'available_standards',
        'state_grade',
    ],
    components: {
        Page
    },
    computed: {

    },
    methods: {

    },
    mounted () {
        this.pages = _.cloneDeep(this.unit_layout)
    }
}
</script>
